import React from "react";
import styled from "styled-components";
import {isMobile} from 'react-device-detect';

const Show = styled.section`
`

function ShowFeatured({show}) {
  return (
    <Show>    
        {show.title}
    </Show>
  );
}

export default ShowFeatured;